// Lib
import { combineReducers } from 'redux-immutable';

// Reducers
import elementId from './elementModalElementIdReducer';

export default combineReducers({
    elementId,
});
